/* eslint-disable no-underscore-dangle */

import { make } from './Action'
import Constants from './Constants'
import NotifyActions from './NotifyActions'

const LOADING_PROJECTS = 'LOADING_PROJECTS';
const GET_PROJECTS = 'GET_PROJECTS';
const PROJECTS_ERROR = 'PROJECT_ERRORS';

const GET_PROJECT = 'GET_PROJECT';
const PROJECT_ERROR = 'PROJECT_ERROR';

const ADD_BLUEPRINT = 'ADD_BLUEPRINT';
const REMOVE_BLUEPRINT = 'REMOVE_BLUEPRINT';
const CHANGE_PROJECT = 'CHANGE_PROJECT';
const UPDATE_PROJECT = 'UPDATE_PROJECT'

const ADD_API_ACCESS = 'ADD_API_ACCESS'
const REMOVE_API_ACCESS = 'REMOVE_API_ACCESS'
const UPDATE_API_ACCESS = 'UPDATE_API_ACCESS'

function _getProjects( projects ) {
  return { 
    type : GET_PROJECTS,
    projects
  };
}

function _projectsError( status, msg ) {
  return { 
    type : PROJECTS_ERROR,
    status,
    message : msg
  };
}

export function getProjects( ) {
  return ( dispatch, getState, api ) => {
    dispatch( { type : LOADING_PROJECTS } );

    return api.projects( ).list()
      .then( ( result ) => {
        dispatch( _getProjects( result.items ) )
      } )
      .catch( ( ex ) => {
        console.log( 'err from getProjects', ex );

        const res = ex.response;
        if ( res ) {
          const msg = ( ex.body && ex.body.message ) || ex.message || ex.statusText;
          dispatch( _projectsError( res.status, msg ) )
        } else {
          dispatch( _projectsError( ex ) )
        }
      } )
  };
}

/**
 * addProject( name, history )
 **/
function createProject( data, history ) {
  return _createProject( data, null, history )
}
const _createProject = make( 'createProject', Constants.ADD_PROJECT, 'project', 'Failed to add project', ( err, result, name, nullOpts, history ) => {
  if ( result && history ) { 
    history.push( `/project/${result.id}/blueprint` )
  }
} )
const deleteProject = make( 'deleteProject', Constants.REMOVE_PROJECT, ( msg, result ) => { msg.id = result.id }, 'Failed to delete project' )

function _getProject( project ) {
  return { 
    type : GET_PROJECT,
    project
  };
}

function _projectError( projectId, status, msg ) {
  return { 
    type : PROJECT_ERROR,
    projectId,
    status,
    message : msg
  };
}

export function getProject( projectId, options ) {
  return ( dispatch, getState, api ) => {
    const opts = { ...options }
    return api.project( projectId ).get( opts )
      .then( ( sProject ) => {
        dispatch( _getProject( sProject ) )
      } )
      .catch( ( ex ) => {
        const res = ex.response
        if ( res ) {
          const msg = ( ex.body && ex.body.message ) || ex.message || ex.statusText;
          console.log( 'ERROR in getProject', ex, ex.body, res );
          dispatch( _projectError( projectId, res.status, msg ) )
        } else {
          console.log( 'ERROR dispatching getProject', ex );
        }
      } )
  };
}

export function updateProject( project, data ) {
  return function( dispatch, getState, api ) {

    return api.project( project ).update( data )
      .then( ( projectData ) => {
        dispatch( { type : GET_PROJECT, project : projectData } ) 
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Error Updating Project', ex ) )
      } )
  };
}

function _addBlueprint( blueprint, history ) {
  return { 
    type : ADD_BLUEPRINT,
    blueprint,
    history
  };
}

export function addBlueprint( project, blueprint, history ) {
  return ( dispatch, getState, api ) => {
    // handle these if the blueprint is an import
    const attributes = blueprint.attributes
    delete blueprint.errors 
    delete blueprint.attributes
    let _blueprint 
    const handleBlueprint = ( bData ) => {
      _blueprint = bData
      return loadAttributes( 0 )
    }
    const loadAttributes = ( next ) => {
      if ( attributes && attributes.length > 0 && next < attributes.length ) {
        return api.addAttribute( _blueprint, attributes[next] )
          .then( () => { return loadAttributes( next + 1 ) } )
          .catch( ( ex ) => {
            dispatch( NotifyActions.warn( 'Error Adding Attributes', ex ) )
            loadAttributes( next + 1 )
          } )
      } 
      dispatch( _addBlueprint( _blueprint, history ) )
      return _blueprint
      
    }
    return api.addBlueprint( project, blueprint )
      .then( handleBlueprint )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Error Creating Blueprint', ex ) )
        console.log( 'ERROR in addBlueprint', ex );
      } )
  }
}

export function _removeBlueprint( blueprint ) {
  return {
    type : REMOVE_BLUEPRINT,
    blueprint
  };
}

export function removeBlueprint( blueprint ) {
  return function( dispatch, getState, api ) {

    return api.removeBlueprint( blueprint )
      .then( ( sBlueprint ) => {
        dispatch( _removeBlueprint( blueprint ) )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in removeBlueprint', ex );
        dispatch( NotifyActions.requestError( 'Error removing Blueprint', ex ) )

      } )
  };
}

export function changeProject( project, key, value ) {
  return {
    type : CHANGE_PROJECT,
    project,
    key,
    value
  }
}

module.exports = {
  LOADING_PROJECTS,
  GET_PROJECTS,
  PROJECTS_ERROR,
  GET_PROJECT,
  UPDATE_PROJECT,
  PROJECT_ERROR,
  CHANGE_PROJECT,
  ADD_BLUEPRINT,
  REMOVE_BLUEPRINT,
  ADD_API_ACCESS,
  REMOVE_API_ACCESS,
  UPDATE_API_ACCESS,

  getProject,
  getProjects,
  updateProject,
  createProject,
  deleteProject,

  addBlueprint,
  removeBlueprint,
  changeProject
}
